import request from '@/utils/http';

// 车次查询接口
export const search = (params) => {
    return request({
        url: '/api-tms/lineDetail/selectAllPage',
        method: 'post',
        data: params
    });
};

// 车次查询count接口
export const searchCount = (params) => {
    return request({
        url: '/api-tms/lineDetail/selectAllCount',
        method: 'post',
        data: params
    });
};

// 排车接口
export const save = (params) => {
    return request({
        url: '/api-tms/dispatch/algorithm/save',
        method: 'post',
        data: params
    });
};

// 记录车次号明细信息查看, 记录车次号明细信息查询接口
export const lineOrders = (params) => {
    return request({
        url: '/api-tms/lineOrders',
        method: 'post',
        data: params
    });
};

// 记录作废, 批量作废接口
export const cancel = (params) => {
    return request({
        'url': '/api-tms/lineDetail/cancel',
        method: 'post',
        data: params
    });
};

// 调整页面>>数据显示, 数据查询接口
// cancelFlag 参数：1 只返回 “已废除”运单，0 返回除“已废除”之外的运单，不穿返回所有运单
export const lineDetailWithOrder = (params) => {
    return request({
        'url': '/api-tms/lineDetailWithOrder/search',
        method: 'post',
        data: params
    });
};

// 调整页面>>运单查询 (添加窗口查询)
export const queryTransportList = (params) => {
    return request({
        url: '/api-tms//transport/selectallPage',
        method: 'post',
        data: params
    });
};

// 调整页面>>运单查询 (添加窗口查询) 数量
export const queryTransportListCount = (params) => {
    return request({
        url: '/api-tms//transport/selectAllTransportsCount',
        method: 'post',
        data: params
    });
};

// 调整页面>>排车明细{添加,删除}, 现有排车加减单接口
export const algorithmOperate = (params) => {
    return request({
        url: '/api-tms/transport/algorithmOperate',
        method: 'post',
        data: params
    });
};

// 调整页面>>排车单之间拖拉加减单, 现有排车加减单接口, 暂不做

// 调整页面>>排车保存, 现有排车保存接口
export const dispatchSave = (params) => {
    return request({
        url: '/api-tms/dispatch/algorithm/save',
        method: 'post',
        data: params
    });
};

// 调整页面>>排车明细上下拖拉调整顺序, 顺序调整接口
export const lineOrderSort = (params) => {
    return request({
        url: '/api-tms/lineOrder/sort',
        method: 'post',
        data: params
    });
};
export const getDetailStatistics = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail/count`,
        method: 'post',
        data
    });
};

// 车次调整重算
export const adjustConfirmRecompute = (data) => {
    return request({
        url: '/api-tms/line/detail/operate',
        method: 'post',
        data
    });
};
// 车次获取里程
export const calculate = (data) => {
    return request({
        url: '/api-tms/algorithm/line/distance/calculate',
        method: 'post',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
